import Vue from 'vue'

import App from './App.vue'
import router from './router'
import store from './store'
import '@/misc/register-service-worker'
import '@/misc/handle-network-status'
// import '@/firebase/init'
// import '@/firebase/authentication'
import '@/misc/handle-apple-install-prompt'
import 'pwacompat'
import { VueHammer } from 'vue2-hammer';

Vue.config.productionTip = false

Vue.use(VueHammer);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

console.log(`
🍱 This app was bootstrapped with bento-starter 🍱

👉 https://bento-starter.netlify.com/

`)
